import { render, staticRenderFns } from "./Shaker.vue?vue&type=template&id=1210bbe0&"
import script from "./Shaker.vue?vue&type=script&lang=js&"
export * from "./Shaker.vue?vue&type=script&lang=js&"
import style0 from "./Shaker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports